module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isMobile) ? _c('div', {
    staticClass: "transparent-panel",
    attrs: {
      "id": "mobile-tools-bar"
    }
  }, [_c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": _vm.toggleLocation
    }
  }, [_c('icon', {
    class: {
      'icon-active': _vm.locationActive
    },
    attrs: {
      "name": "map-marker"
    }
  }), _vm._v(" "), (_vm.gettingLocation) ? _c('div', {
    staticClass: "loader",
    attrs: {
      "id": "map-marker-loader"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": function($event) {
        return _vm.toggleTool('layerSelector')
      }
    }
  }, [_c('icon', {
    class: _vm.activeClass('layerSelector'),
    attrs: {
      "name": "slms-layers"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": function($event) {
        return _vm.toggleTool('measure')
      }
    }
  }, [_c('icon', {
    class: _vm.activeClass('measure'),
    attrs: {
      "name": "slms-ruler"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": function($event) {
        return _vm.toggleTool('annotations')
      }
    }
  }, [_c('icon', {
    class: _vm.activeClass('annotations'),
    attrs: {
      "name": "sticky-note"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": function($event) {
        return _vm.toggleTool('feedback')
      }
    }
  }, [_c('icon', {
    class: _vm.activeClass('feedback'),
    attrs: {
      "name": "slms-feedback"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": function($event) {
        return _vm.toggleTool('kmlUpload')
      }
    }
  }, [_c('icon', {
    class: _vm.activeClass('kmlUpload'),
    attrs: {
      "name": "slms-kml"
    }
  })], 1), _vm._v(" "), (_vm.enablePrint) ? _c('div', {
    staticClass: "mobile-tool-bar-button",
    on: {
      "click": _vm.printMap
    }
  }, [_c('icon', {
    attrs: {
      "name": "slms-pdf"
    }
  }), _vm._v(" "), (_vm.printingInProgress) ? _c('div', {
    staticClass: "loader",
    attrs: {
      "id": "print-map-loader"
    }
  }) : _vm._e()], 1) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74f890de","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileToolsBar.vue
// module id = 621
// module chunks = 2